import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, Input } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";

import {
  getProductImagesByProductDetailIdRequest,
  setDefaultImageForProductDetailRequest,
} from "store/actions";
import { makeProductDetailSelectField } from "store/ProductDetail/selector";

class ImageList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getProductImagesByProductDetailIdRequest(
      this.props.productDetailId
    );
  }

  handleOnSetDefault = (e, productImage) => {
    e.preventDefault();
    if (!productImage.isDefault) {
      this.props.setDefaultImageForProductDetailRequest(
        this.props.productDetailId,
        productImage.productImage
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4 px-0">
          <Row>
            {this.props.productImageData.map((imageData, index) => (
              <Col xl="3" md="6" key={index}>
                <Card className="product-box">
                  <CardBody className="p-0">
                    <div className="product-img border">
                      <div className="product-checkbox">
                        <Input
                          type="checkbox"
                          name="deleteImages"
                          onChange={(e) =>
                            this.props.onChangeCheckBox(
                              e,
                              imageData.productImage
                            )
                          }
                        />
                      </div>
                      <img
                        src={imageData.productImageUrl}
                        loading="lazy"
                        className="img-fluid rounded-top mx-auto d-block"
                        alt={imageData.productImage}
                        style={{minHeight: 100}}
                      />
                      <div className="product-overlay">
                        <ul className="list-inline product-links social-links mb-0">
                          <li className="list-inline-item">
                            {/* <Tooltip placement="top" isOpen={this.state[`i${index}`]} target="i1" toggle={() => this.setState({ `i${index}`: !this.state.i1 })}>View</Tooltip> */}
                            <a
                              href={imageData.productImageUrl}
                              rel="noopener noreferrer"
                              target="_blank"
                              id="i1"
                              className="team-member"
                            >
                              <i className="fa fa-eye"></i>
                            </a>
                          </li>
                          <li className="list-inline-item">
                            {/* <Tooltip placement="top" isOpen={this.state.i2} target="i2" toggle={() => this.setState({ i2: !this.state.i2 })}>Set as Default</Tooltip> */}
                            <a
                              href="/"
                              id="i2"
                              onClick={(e) =>
                                this.handleOnSetDefault(e, imageData)
                              }
                              className="team-member"
                            >
                              <i className="fa fa-check-circle"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productImageData: makeProductDetailSelectField("productImageData"),
});

const withConnect = connect(mapStatetoProps, {
  getProductImagesByProductDetailIdRequest,
  setDefaultImageForProductDetailRequest,
});

export default compose(withConnect, withRouter)(ImageList);
